import Stats from "./Stats";
import Table from "./Table";

function Payments() {
  return (
    <div>
        <Stats />
        <Table />
    </div>
  );
}

export default Payments;
